import React from "react";
import "./Keynotes.css";

export const Keynotes = () => {
  return (
    <div className="keynote-layout">
      <div className="keynote-text-layout">
        <h2>Keynotes</h2>
        <h3>Keynote 1:</h3>
        <h3>
          Professor Vinny Cahill, Professor of Computer Science, Trinity College
          Dublin
        </h3>
        <h4>
          Combining Deep Reinforcement Learning and Swarm Intelligence to
          Optimize Road Transportation
        </h4>
        <br />
        <h4>Abstract</h4>
        <p>
          Road transportation is arguably the lifeblood of human connectedness
          and economic progress, making roads a critical shared societal
          resource. Currently, however, the use of roads is often essentially
          uncontrolled leading, for example, to high levels of traffic
          congestion with significant negative environmental, public health, and
          economic consequences. Thus, there is an urgent need to fundamentally
          rethink how use of roads is controlled with a view to achieving a
          sustainable road transportation system that makes optimal use of
          available infrastructure while offering the efficiency, comfort,
          convenience, and access that society needs. Of particular importance
          is the ability of offer predictable journey times in support of the
          uptake of sustainable road transportation including future public,
          shared, and on-demand mobility services and of on-time delivery of
          goods.{" "}
        </p>
        <p>
          This talk will address how the combination of (hierarchical)
          multi-agent deep reinforcement learning and swarm intelligence can be
          harnessed to support optimization of road usage while taking account
          of the complexity and inherent non-stationarity of traffic systems as
          well as the need to adapt to the many transient perturbations that
          effect traffic flow. The talk will consider how these techniques can
          be applied to the coordination of connected and automated vehicles to
          enable the use of traffic shaping mechanisms, in particular, our
          proposed slot-based driving model, to provide predictability in
          journey times.{" "}
        </p>
        <p>
          Finally, the talk will expose some emerging requirements that are
          being addressed in current work including dealing with long-sequence
          decision making and unobserved confounding phenomena.
        </p>
        <div className="keynote-biography-layout">
          <img
            className="keynote-img"
            src={"./images/profiles/vinny-cahill.jpg"}
          />
          <div className="keynote-text">
            <h4>Speaker Profile</h4>

            <p>
              Professor Vinny Cahill is Professor of Computer Science at Trinity
              College Dublin, Ireland where he has also served as Vice-President
              for Research and Dean of the Faculty of Engineering, Mathematics
              and Science. His research addresses optimization of urban resource
              usage and service delivery in order to improve the quality of life
              and sustainability of cities. Of particular current interest is
              the design of new AI-based techniques for urban traffic control,
              highway management and ‘mobility as a service’ to support
              sustainable mobility with the goal of optimizing travel-time
              reliability for travellers and freight. He is currently leading
              Trinity’s{" "}
              <a href="https://www.tcd.ie/e3/summit/"> E3 SUMMIT initiative</a>{" "}
              which is bringing together a multidisciplinary team of researchers
              to reimagine, design, and promote future models of
              city/region-scale sustainable mobility provision and the
              governance structures, policies and technologies that will enable
              them. He is co-PI of the SFI-funded ClearWay project which is
              developing novel reinforcement learning and swarm intelligence
              techniques for transport optimization.
            </p>
          </div>
        </div>
        <br />
        <hr />
        <h3>Keynote 2:</h3>
        <h3>
          {" "}
          Professor Akane Sano, Associate Professor, Electrical and Computer
          Engineering, Rice University
        </h3>
        <h4>Human-Centered Multimodal AI for Health and Wellbeing</h4>
        <br />
        <h4>Abstract</h4>
        <p>
          Sensors and computing systems play a crucial role in enabling
          continuous, unobtrusive health monitoring, providing real-time
          insights into behaviors, physiology, and environmental factors.
          Integrating multimodal data—such as clinical assessments and
          wearable/mobile sensing has great potential for predicting and
          improving health outcomes.{" "}
        </p>
        <p>
          AI advancements, particularly large language models (LLMs), offer new
          opportunities to fuse diverse multimodal data, improving model
          adaptability and enabling more equitable and personalized health
          solutions. However, challenges in data collection, modeling, feedback,
          and deployment must be addressed to fully realize these benefits.
        </p>
        <p>
          In this talk, I will explore these challenges and present advancements
          and future directions in measuring, predicting, and supporting health
          and well-being.{" "}
        </p>
        <p>Specifically, I will focus on three critical areas:</p>
        <ul>
          <li>
            Developing robust inference models that integrate diverse,
            multimodal data sources to improve prediction and reliability.
          </li>
          <li>
            Ensuring fairness, representation, and interpretability in AI-driven
            health predictions by addressing bias, optimizing model
            transparency, and synthesizing balanced datasets for equity.
          </li>
          <li>
            Designing adaptive and interpretable feedback systems to personalize
            and optimize real-time interventions for patients and healthcare
            providers.
          </li>
        </ul>
        <p>
          By exploring lessons learned and emerging research directions, this
          talk will pave the way for scalable, human-centered AI solutions that
          enhance health monitoring and intervention systems.
        </p>
        <div className="keynote-biography-layout">
          <img
            className="keynote-img"
            src={"./images/profiles/Akane_Sano.webp"}
          />
          <div className="keynote-text">
            <p>
              Akane Sano is an Assistant Professor at Rice University,
              Department of Electrical Computer Engineering, Computer Science,
              and Bioengineering. She directs the Computational Wellbeing Group
              and is a member of Scalable Health Labs.
            </p>
            <p>
              Her research includes data science, machine learning, and
              human-centered intelligent systems for health and wellbeing and
              spans in the field of affective computing, ubiquitous and wearable
              computing, and biobehavioral sensing and analysis/modeling. Her
              research targets (1) the analysis and modeling of human ambulatory
              multimodal time series data including physiological, biological
              and behavioral data and surveys for measuring, predicting,
              improving, and understanding human physiology and behavior and
              human factors such as health, wellbeing, and performance and (2)
              development of human-centered computing technologies for health,
              wellbeing, and performance. She has been working on developing
              tools, algorithms, and systems to measure, forecast, understand
              and improve health and wellbeing using multimodal data from mobile
              and wearable sensors, devices in daily life settings, and clinical
              assessment especially for measuring, predicting, and
              intervening/improving clinical outcomes, stress, mental health,
              sleep, and performance.{" "}
            </p>
            <p>
              She obtained her PhD at MIT Media Lab, and her MEng and BEng at
              Keio University, Japan. Before she joined Rice University, she was
              a Research Scientist in Affective Computing Group at MIT Media
              Lab, and a visiting scientist/lecturer at People-Aware Computing
              Lab, Cornell University. Before she came to the US, she was a
              researcher/engineer at Sony Corporation focusing on wearable
              computing, intelligent systems, and human/computer interaction.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
